import { showNotification } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { customAxios } from "lib/axios";

export type NotificationReadInput = {
  notificationIds: string[];
  read: boolean;
};

export type Notification = {
  _id: string;
  title: string;
  body: string;
  read: boolean;
  createdAt: string;
};

export type NotificationReadResponse = {
  success: boolean;
  message: string;
  data: {
    modifiedCount: number;
  };
};

const updateNotificationsRead = async (
  userId: string,
  payload: NotificationReadInput
): Promise<NotificationReadResponse> => {
  const res: AxiosResponse<NotificationReadResponse> = await customAxios.patch(
    `/notifications/${userId}/notifications/read`,
    payload
  );
  return res.data;
};

export const useUpdateNotificationsRead = (userId: string) => {
  const queryClient = useQueryClient();

  return useMutation<NotificationReadResponse, Error, NotificationReadInput>({
    mutationFn: (payload) => updateNotificationsRead(userId, payload),

    onSuccess: async () => {
      showNotification({
        title: "Notifications updated",
        message: " status updated successfully",
        color: "green",
      });

      await queryClient.invalidateQueries({
        queryKey: ["notifications", userId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["unreadNotificationsCount", userId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["notifications"],
      });
    },

    onError: (err) => {
      showNotification({
        title: "Update failed",
        message: "Could not update notifications",
        color: "red",
      });
    },
  });
};
